import { centerCrop, makeAspectCrop, PercentCrop } from 'react-image-crop';

/**
 * Default cropping aspect ratio
 */
export const CROP_ASPECT_RATIO = 9 / 14;

/**
 * This is to demonstrate how to make and center a % aspect crop
 * which is a bit trickier so we use some helper functions.
 *
 * @param mediaWidth The width of the cropped image
 * @param mediaHeight The height of the cropped image
 * @param aspect The aspect ratio of the cropping.
 */
export function centerAspectCrop(
  mediaWidth: number,
  mediaHeight: number,
  aspect: number
): PercentCrop {
  return centerCrop(
    makeAspectCrop(
      {
        unit: '%',
        width: 90,
        height: 100,
      },
      aspect,
      mediaWidth,
      mediaHeight
    ),
    mediaWidth,
    mediaHeight
  );
}
